// LoadFailure.js
// The one message for a read that failed — a listener that errored, a fetch that
// rejected — shown in place of a surface's empty state, so "could not load" is never
// mistaken for "verified empty". Retry is offered where the caller can re-read or
// resubscribe (a Firestore listener that errors has stopped for good; only a fresh
// subscription brings it back).
import React from 'react';
import { Box, Button, Typography } from '@mui/material';

export const loadFailureMessage = (thing) =>
  `Unable to load ${thing} — refresh and retry. If this fails, contact support.`;

export default function LoadFailure({ thing, onRetry, sx, variant = 'body2', align = 'center' }) {
  return (
    <Box sx={{ p: 2, textAlign: align, ...sx }}>
      <Typography variant={variant} color="error">{loadFailureMessage(thing)}</Typography>
      {onRetry && (
        <Button size="small" onClick={onRetry} sx={{ mt: 0.5, textTransform: 'none' }}>
          Retry
        </Button>
      )}
    </Box>
  );
}
